"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.F_PlainDate_Elapsed = exports.UnitElapsed = void 0;
var F_PlainDate_1 = __importDefault(require("./F_PlainDate"));
var PlainDateBuilder_1 = require("./PlainDateBuilder");
var UnitElapsed = /** @class */ (function () {
    /** @hidden */
    function UnitElapsed(plainDate, unit) {
        this.plainDate = plainDate;
        this.unit = unit;
        this.after = this.after.bind(this);
        this.before = this.before.bind(this);
        this.toIntTowardsZero = this.toIntTowardsZero.bind(this);
    }
    /** @hidden */
    UnitElapsed.prototype.toIntTowardsZero = function (total) {
        var ceilFloor = total < 0 ? Math.ceil(total) : Math.floor(total);
        // -0 is a thing in javascript, and is weird.
        return Object.is(ceilFloor, -0) ? 0 : ceilFloor;
    };
    UnitElapsed.prototype.after = function (arg1, arg2, arg3) {
        var _a;
        var otherPlainDateIso = arg1 instanceof F_PlainDate_1.default ? arg1.toIso() : (_a = (0, PlainDateBuilder_1._constructPlainDate)(arg1, arg2, arg3)) === null || _a === void 0 ? void 0 : _a.toIso();
        if (!otherPlainDateIso) {
            throw new Error('not other date');
        }
        return this.toIntTowardsZero(this.plainDate.since(otherPlainDateIso).total({
            unit: this.unit,
            relativeTo: this.plainDate
        }));
    };
    UnitElapsed.prototype.before = function (arg1, arg2, arg3) {
        var _a;
        var otherPlainDateIso = arg1 instanceof F_PlainDate_1.default ? arg1.toIso() : (_a = (0, PlainDateBuilder_1._constructPlainDate)(arg1, arg2, arg3)) === null || _a === void 0 ? void 0 : _a.toIso();
        if (!otherPlainDateIso) {
            throw new Error('not other date');
        }
        return this.toIntTowardsZero(this.toIntTowardsZero(this.plainDate.since(otherPlainDateIso).total({
            unit: this.unit,
            relativeTo: this.plainDate
        })) * -1);
    };
    return UnitElapsed;
}());
exports.UnitElapsed = UnitElapsed;
var F_PlainDate_Elapsed = /** @class */ (function () {
    /** @hidden */
    function F_PlainDate_Elapsed(plainDate) {
        this.plainDate = plainDate;
        this.days = new UnitElapsed(this.plainDate, 'days');
        this.weeks = new UnitElapsed(this.plainDate, 'weeks');
        this.months = new UnitElapsed(this.plainDate, 'months');
        this.years = new UnitElapsed(this.plainDate, 'years');
    }
    return F_PlainDate_Elapsed;
}());
exports.F_PlainDate_Elapsed = F_PlainDate_Elapsed;
//# sourceMappingURL=F_PlainDate_Elapsed.js.map